import { useGetUserCredentialsQuery } from '@sketch/gql-types'

export const useUserSignedIn = () => {
  const { data } = useGetUserCredentialsQuery({
    fetchPolicy: 'cache-only',
  })

  return !!data?.userCredentials?.authToken
}
